import { styled } from '@mui/material/styles';

import Tooltip from '@mui/material/Tooltip';
import { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

/**
 * Tooltips display informative text when users hover over, focus on, or tap an element.
 *
 * It extends Mui's `Tooltip` component. ([See documentation](https://mui.com/material-ui/react-tooltip/#main-content))
 *
 * - The tooltip should be displayed above an element.
 * - It should have the arrow param activated.
 * - It never exceed `500px` large.
 */
const HiTooltip = styled(
  ({
    className,
    children,
    placement = 'top',
    arrow = true,
    ...other
  }: TooltipProps) => (
    <Tooltip
      {...other}
      placement={placement}
      arrow={arrow}
      classes={{ popper: className }}
    >
      {children}
    </Tooltip>
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#363D40',
    padding: theme.spacing(2),
    marginBottom: `${theme.spacing(2)} !important`,
    marginTop: `${theme.spacing(2)} !important`,
    maxWidth: 500
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#363D40'
  }
}));

export default HiTooltip;
